export default __webpack_public_path__ + "static/media/f5-logo.77988e71.svg";